<template>
  <el-select
    :value="value"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    :popper-append-to-body="true"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="`${item.code}（${item.name}）`"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { productList } from '../../service/getData'

export default {
  props: {
    value: '',
    category: {
      type: Number,
      default: 0,
    },
    templateid: {
      type: Number,
      default: 0,
    },
    transfer: {
      type: Boolean,
      default: false,
    },
    baseid: {
      type: Number,
      default: 0,
    },
    wellid: {
      type: Number,
      default: 0,
    },
    stockType: {
      type: Number,
      default: 0,
    },
    codeType: {
      type: Number,
      default: 1,
    },
    status: {
      type: Number,
      default: 0,
    },
    applyFilter: {
      type: Boolean,
      default: false,
    },
    productGroupId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  async created() {
    if (this.value) {
      await this.requestData('default')
      this.$emit('info', this.lists.filter((item) => item.id == this.value)[0])
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
      this.$emit('info', this.lists.filter((item) => item.id == e)[0])
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          code: query == 'default' ? '' : query,
          category: this.category,
          product_template_id: this.templateid,
          id: query == 'default' ? this.value : 0,
          select_option: true,
          transfer_list: this.transfer,
          base_id: this.baseid,
          drill_well_id: this.wellid,
          stock_type: this.stockType,
          code_type: this.codeType,
          status: this.status,
          apply_filter: this.applyFilter,
          product_group_id: this.productGroupId,
        }

        let res = await productList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>
